import { ISwappableListItem } from '../models/IListItem';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
})

export default class SwapList<T> extends Vue {
    @Prop({ required: true }) listItems!: ISwappableListItem<T>[];

    private onItemSelected(item: ISwappableListItem<T>) {
        this.$emit('swapItemSelected', item);
    }
}
